module.exports = __webpack_public_path__ + "img/logo-serviroute-2.f8f617e8.png";